import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { InformationItem } from '../../models/Information';

interface IInformationService {
  getInformation: (
    informationId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<InformationItem>>;
}

export const informationService: IInformationService = {
  getInformation(informationId, axiosConfig) {
    return ajax.get<InformationItem>(
      `${config.benefitApiUrl}/information/${informationId}`,
      axiosConfig,
    );
  },
};
